var _circle, _circle2, _rect, _line, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 30,
    viewBox: "0 0 44 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.2422,
    cy: 16.5938,
    r: 4,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.4062,
    cy: 16.5938,
    r: 4,
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37.0117,
    height: 24.1875,
    rx: 1.5,
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.585938,
    y1: 6.24609,
    x2: 37.7347,
    y2: 6.24609,
    stroke: "black",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 17C34.685 17 32 19.6987 32 23.0307C32 24.1614 32.315 25.2319 32.87 26.1365C33.905 27.8854 35.81 29.0613 38 29.0613C40.19 29.0613 42.095 27.8854 43.13 26.1365C43.685 25.2319 44 24.1614 44 23.0307C44 19.6987 41.315 17 38 17ZM41.105 22.3824L37.91 25.3525C37.7 25.5485 37.415 25.654 37.145 25.654C36.86 25.654 36.575 25.5485 36.35 25.3223L34.865 23.8297C34.43 23.3925 34.43 22.6688 34.865 22.2316C35.3 21.7944 36.02 21.7944 36.455 22.2316L37.175 22.9553L39.575 20.7239C40.025 20.3018 40.745 20.3319 41.165 20.7842C41.585 21.2365 41.555 21.9452 41.105 22.3824Z",
    fill: "#367B3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccess);
export default __webpack_public_path__ + "static/media/Payment-success.e2e2568e242ff0a7b09f0723624bcc04.svg";
export { ForwardRef as ReactComponent };